import { Observable } from 'rxjs';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material';
import { Injectable } from '@angular/core';

import { AppComfirmComponent } from './app-confirm.component';
import { take } from 'rxjs/operators';

interface confirmData {
  title?: string,
  message?: string
}

@Injectable()
export class AppConfirmService {

  constructor(private _matDialog: MatDialog) { }

  public confirm(data:confirmData = {}): Observable<boolean> {
    data.title = data.title || 'Importante';
    data.message = data.message || '¿Estas seguro?';
    let dialogRef: MatDialogRef<AppComfirmComponent>;
    dialogRef = this._matDialog.open(AppComfirmComponent, {
      disableClose: true,
      data: { title: data.title, message: data.message }
    });
    return dialogRef.afterClosed().pipe(take(1));
  }
}